import React from 'react';
import moment from 'moment';

import { faSync } from '@fortawesome/free-solid-svg-icons/faSync';

import { env } from '~/commons/config';
import FormHttpBtn from '~/commons/components/FormHttpBtn.jsx';
import ListResource from './ListResource.jsx';

const api = '/api/core/exchange-rates';

const ListExchangeRates = ({ res = {}, sync }) => (
  <ListResource
    {...{
      searchable: true,
      api,
      sort: { refCode: 1 },
      actions: {
        fileImport: true,
        fileExport: true,
      },
      cols: [
        { key: 'from', sortable: true },
        { key: 'to', sortable: true },
        { key: 'rate' },
        {
          key: 'startAt',
          getter: (v) => (v ? moment(v).format(env.f.dt) : ''),
        },
      ],
    }}>
    {() => (
      <>
        <FormHttpBtn
          {...{
            res,
            onClick: () => sync(),
            className: 'btn-secondary',
            icon: faSync,
          }}
          >Sync</FormHttpBtn>
      </>
    )}
  </ListResource>
);

export default ListExchangeRates;
